import { createAction, props } from '@ngrx/store';
import { B2bUnitState } from '@b2b/features/b2b-unit/core/store/b2b-unit.states';

// B2B Unit Details Actions
export const GET_B2B_UNIT = '[B2B_UNIT]: GET B2B_UNIT';
export const GET_B2B_UNIT_SUCCESS = '[B2B_UNIT]: GET B2B_UNIT - SUCCESS';
export const GET_B2B_UNIT_FAIL = '[B2B_UNIT]: GET B2B_UNIT - FAIL';

// Payment Method Actions
export const GET_B2B_UNIT_PAYMENT_METHOD = '[B2B_UNIT]: GET B2B_UNIT PAYMENT METHOD';
export const GET_B2B_UNIT_PAYMENT_METHOD_SUCCESS = '[B2B_UNIT]: GET B2B_UNIT PAYMENT METHOD - SUCCESS';
export const GET_B2B_UNIT_PAYMENT_METHOD_FAIL = '[B2B_UNIT]: GET B2B_UNIT PAYMENT METHOD - FAIL';
export const GET_DEFAULT_PAYMENT_METHOD = '[B2B_UNIT]: GET DEFAULT PAYMENT METHOD';
export const GET_DEFAULT_PAYMENT_METHOD_SUCCESS = '[B2B_UNIT]: GET DEFAULT PAYMENT METHOD - SUCCESS';
export const GET_DEFAULT_PAYMENT_METHOD_FAIL = '[B2B_UNIT]: GET DEFAULT PAYMENT METHOD - FAIL';

// B2B Unit Details
export const getB2BUnit = createAction(GET_B2B_UNIT, props<{ b2bUnitId: string }>());
export const getB2BUnitSuccess = createAction(
  GET_B2B_UNIT_SUCCESS,
  props<{ b2bUnit: Partial<B2bUnitState['currentB2bUnit']> }>(),
);
export const getB2BUnitFail = createAction(GET_B2B_UNIT_FAIL, props<{ message: string }>());

// Payment Methods
export const getB2bUnitPaymentMethods = createAction('[B2bUnit] Get B2b Unit Payment Methods');

export const getB2bUnitPaymentMethodsSuccess = createAction(
  GET_B2B_UNIT_PAYMENT_METHOD_SUCCESS,
  props<{ paymentMethods: Partial<B2bUnitState['paymentMethods']> }>(),
);

export const getB2bUnitPaymentMethodsFail = createAction(
  GET_B2B_UNIT_PAYMENT_METHOD_FAIL,
  props<{ message: string }>(),
);
